import React from 'react';
import Icon from '../icons/Icon';
import './TagFilter.css';

const TagFilter = ({ tags, selectedTags, onTagToggle }) => {
  if (!tags || tags.length === 0) {
    return null;
  }

  const isTagSelected = (tag) => {
    return selectedTags.includes(tag);
  };

  const handleTagClick = (tag) => {
    onTagToggle(tag);
  };

  return (
    <div className="tag-filter">
      <h3 className="tag-filter-title">Filter by Tags</h3>
      <div className="tag-filter-list">
        {tags.map((tag) => (
          <button
            key={tag}
            className={`tag-filter-item ${isTagSelected(tag) ? 'active' : ''}`}
            onClick={() => handleTagClick(tag)}
          >
            {tag}
            {isTagSelected(tag) && <span className="tag-filter-check"><Icon name="check" size={14} /></span>}
          </button>
        ))}
      </div>
      {selectedTags.length > 0 && (
        <button
          className="tag-filter-clear"
          onClick={() => selectedTags.forEach(tag => onTagToggle(tag))}
        >
          Clear all tags
        </button>
      )}
    </div>
  );
};

export default TagFilter;

